export default "__VITE_ASSET__BiCrOiQa__"